var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.9999 8.33301C41.7591 8.33301 33.7032 10.7767 26.8512 15.3551C19.9991 19.9335 14.6586 26.4409 11.505 34.0545C8.35131 41.6681 7.52617 50.0459 9.13388 58.1284C10.7416 66.211 14.71 73.6353 20.5372 79.4625C26.3643 85.2896 33.7886 89.258 41.8712 90.8657C49.9537 92.4734 58.3315 91.6483 65.9451 88.4947C73.5587 85.341 80.0661 80.0005 84.6445 73.1484C89.2229 66.2964 91.6666 58.2406 91.6666 49.9997C91.6666 44.5279 90.5889 39.1098 88.4949 34.0545C86.401 28.9993 83.3318 24.406 79.4627 20.5369C75.5936 16.6678 71.0003 13.5986 65.9451 11.5047C60.8899 9.41075 55.4717 8.33301 49.9999 8.33301ZM49.9999 83.333C43.4072 83.333 36.9626 81.378 31.4809 77.7153C25.9993 74.0526 21.7269 68.8467 19.204 62.7558C16.681 56.6649 16.0209 49.9627 17.3071 43.4967C18.5933 37.0306 21.768 31.0912 26.4297 26.4294C31.0915 21.7677 37.0309 18.593 43.4969 17.3068C49.963 16.0207 56.6652 16.6808 62.7561 19.2037C68.8469 21.7266 74.0529 25.999 77.7156 31.4807C81.3783 36.9623 83.3333 43.407 83.3333 49.9997C83.3333 58.8402 79.8214 67.3187 73.5702 73.5699C67.319 79.8211 58.8405 83.333 49.9999 83.333Z",
    fill: "#1F4B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3333 49.9997H91.6667C91.6667 44.5279 90.5889 39.1098 88.495 34.0545C86.401 28.9993 83.3319 24.406 79.4628 20.5369C75.5937 16.6678 71.0004 13.5986 65.9451 11.5047C60.8899 9.41075 55.4717 8.33301 50 8.33301V16.6663C58.8405 16.6663 67.319 20.1782 73.5702 26.4294C79.8214 32.6807 83.3333 41.1591 83.3333 49.9997Z",
    fill: "#1F4B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6cfc4c7c7f0c18a67545456ea299ccd7.svg";
export { ForwardRef as ReactComponent };